import React from 'react'
import JSONView from '../components/JSONView'

import { useAuthFunctions } from '../contexts/Auth';

export default function IDPResponse() {
    const auth = useAuthFunctions();
    const [query_json, setQueryJson] = React.useState({
        "state": "Processing"
    });
    const [token_json, setTokenJson] = React.useState({
        "state": "Processing"
    });



    React.useEffect(() => {
        console.log("loaded idpresponse.js");
        const query = window.location.search;
        const params = new URLSearchParams(query);
        const new_query_json = {}; 
        for (const [key, value] of params) {
            new_query_json[key] = value;
        }
        setQueryJson(new_query_json);
        if (new_query_json.code) {
            auth.getFederatedTokens(new_query_json.code)
                .then((response) => {
                    setTokenJson(response);
                    // Then go home
                    window.location.href = "/";
                })
        }
    }, []);

    return (
        <div>
            <h1>IDPResponse</h1>
            <p>Query</p>
            <JSONView target_object={query_json} />
            <p>Token</p>
            <JSONView target_object={token_json} />
            <p>Go Back</p>
            <a href="/">Home</a>
        </div>
    );
}
